import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountNotificationsState } from '../reducers/notifications.reducer';

export const selectAccountNotificationsState = createFeatureSelector<AccountNotificationsState>('accountNotifications');

export const selectAllAccountNotifications = createSelector(
  selectAccountNotificationsState,
  (state) => state.notifications
);

export const selectUnreadAccountNotifications = createSelector(
  selectAllAccountNotifications,
  (notifications) => notifications.filter((n) => !n.readAt)
);

export const selectUnreadCount = createSelector(
  selectUnreadAccountNotifications,
  (notifications) => notifications.length
);

export const selectAccountNotificationsLoading = createSelector(
  selectAccountNotificationsState,
  (state) => state.loading
);

export const selectAccountNotificationsError = createSelector(
  selectAccountNotificationsState,
  (state) => state.error
);
